import React, { useEffect, useState } from 'react';

import { Table } from '../../../../common/table/Table';
import Modal from '../../../../common/modal/Modal';
import { AvailableFormsSearch } from './AvaliableFormsSearch';

export const FormsForVisit = ({
  visit,
  forms,
  setVisit,
  visits,
  showToaster,
  context,
  setSpinnerText,
  editMode,
  setVisits,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [header, setHeader] = useState('');

  useEffect(() => {
    if (editMode) {
      if (visit && visit.forms) {
        const filteredForms = forms.filter((form) =>
          visit.forms.some((formRef) => formRef.formExternalReference === form.formExternalReference)
        );
        setSearchResults(filteredForms);
      }
    } else {
      if (visit && visit.formExternalReferences) {
        const filteredForms = forms.filter((form) =>
          visit.formExternalReferences.some((formRef) => formRef === form.formExternalReference)
        );
        setSearchResults(filteredForms);
      }
    }

    setHeader('Forms for Visit: ' + (visit ? visit.visitCode : ''));
  }, [visit, forms, editMode]);

  const handleAddButtonClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="problem-search-results-container">
      <div className="problem-search-results-table-container">
        {searchResults && (
          <React.Fragment>
            <Table
              tableData={searchResults}
              hiddenColumns={[
                'formExternalReference',
                'selected',
                'studyScheduleExternalReference',
                'scheduleSpecific',
                'studyScheduleName',
              ]}
              searchEnabled={true}
              filterEnabled={false}
              tableTitle={header}
              buttonText="Add/Remove"
              onButtonClick={handleAddButtonClick}
              buttonDisabled={false}
              maxRowCount={4}
              horizontalScroll
            />
            {isModalOpen && (
              <Modal
                closeModal={closeModal}
                setIsModalOpen={setIsModalOpen}
                headerTitle={'Add /Remove Forms'}
                hideButton={true}
                width={'50%'}
                justifyContent={'center'}
                contentPadding={'10px'}
              >
                <AvailableFormsSearch
                  visit={visit}
                  forms={forms}
                  setVisits={setVisits}
                  visits={visits}
                  setVisit={setVisit}
                  closeModal={closeModal}
                  editMode={editMode}
                  setSpinnerText={setSpinnerText}
                  showToaster={showToaster}
                  context={context}
                />
              </Modal>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
